import { useState } from "react";
import { useDispatch } from "react-redux";
import { FormControl as Input } from "react-bootstrap";
import DefaultButton from "../../../../components/DefaultButton";

import Table from "./Table.js";

const TestimonialList = () => {
    const [search, SetSearch] = useState("");

    const dispatch = useDispatch();

    return (
        <div className="card">
            <div className="card-body">
                <h3 className="title">Depoimentos</h3>
                <p className="text-muted">Aqui são listadas todos os depoimentos do site RT</p>
                <hr/>
                <div className="flex jcsb flex-wrap margin-bottom">
                    <Input
                        placeholder="Pesquisar pelo Título"
                        value={search}
                        onChange={e => SetSearch(e.target.value)}
                        style={{width: "50%"}}
                    />
                    <DefaultButton
                        bg="confirm"
                        text="Adicionar novo depoimento"
                        to="/site-rt/depoimentos/criar"
                    />
                </div>
                <Table
                    search={search}
                />
            </div>
        </div>
    );
}

export default TestimonialList;